import React from 'react';

const EarlyAccessButton = () => {
  return (
    <a
      href="/install"
      className="inline-block px-4 py-2 text-sm font-semibold text-white hover:!text-white rounded-lg bg-[#7866CC] hover:bg-[#5E50A0] transition-colors no-underline"
    >
      Get started
    </a>
  );
};

export default EarlyAccessButton;